module.exports = __webpack_public_path__ + "static/media/bank-transactions.d8425022.svg";